import {useEffect, useRef} from 'react';
import {captureSentryException} from 'app/services/sentry/sentryLogging';
import {useDispatch, useSelector} from 'react-redux';
import {reduxSelectCurrentUser} from 'app/hooks/reduxSelectCurrentUser';
import {useNative} from 'app/contexts/NativeContext';

const useInitFirebaseMessaging = () => {
  const dispatch = useDispatch();
  const {initializing, user, notificationPermission} = useSelector(reduxSelectCurrentUser);
  const nativeInfo = useNative();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) {
      return;
    }
    if (!initializing && user && Object.keys(user).length) {
      const initFirebaseMessaging = async () => {
        isInitialized.current = true;
        const {initMessaging} = await import('app/services/firebaseMessaging');
        initMessaging(dispatch, notificationPermission, nativeInfo);
      };

      initFirebaseMessaging().catch(e =>
        captureSentryException(e, {extra: {errorLocation: 'Initializing Firebase Messaging in AppShell'}})
      );
    }
  }, [initializing, user, dispatch, nativeInfo, notificationPermission]);
};

export default useInitFirebaseMessaging;
